import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SnackbarErrorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" data-test-id='snackbar-error-icon'>
      <circle cx='20' cy='20' r='20' className='outline' />
      <circle cx='20' cy='20' r='15' className='background' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 11.25C18.8494 11.25 17.9167 12.1827 17.9167 13.3333V20.8333C17.9167 21.9839 18.8494 22.9167 20 22.9167C21.1506 22.9167 22.0834 21.9839 22.0834 20.8333V13.3333C22.0834 12.1827 21.1506 11.25 20 11.25ZM20 24.5833C18.8494 24.5833 17.9167 25.5161 17.9167 26.6667C17.9167 27.8173 18.8494 28.75 20 28.75C21.1506 28.75 22.0834 27.8173 22.0834 26.6667C22.0834 25.5161 21.1506 24.5833 20 24.5833Z'
        className='content'
      />
    </SvgIcon>
  );
};

export default SnackbarErrorIcon;
